import './DiscountButton.sass';

import React, { FC } from 'react';
import { CurrencyEnum } from '$store/models';
import { formatCurrency } from '$utils';
import { Button } from '$uikit/Button/Button';
import { DiscountButtonProps } from './DiscountButton.interface';
import { useTranslator } from '$hooks';

export const DiscountButton: FC<DiscountButtonProps> = ({
  price,
  priceWithoutDiscount,
  currency = CurrencyEnum.EUR,
  buyText,
  saveText,
  className = '',
  ...buttonProps
}) => {
  const t = useTranslator();

  const savings = priceWithoutDiscount ? priceWithoutDiscount - price : 0;
  const discountPercent = priceWithoutDiscount
    ? Math.round((savings / priceWithoutDiscount) * 100)
    : 0;

  const formattedPrice = formatCurrency(price, currency);
  const formattedSavings = formatCurrency(savings, currency);

  const buyLabel = t(buyText, { price: formattedPrice });
  const saveLabel = t(saveText);

  if (savings <= 0 || discountPercent <= 0) {
    return (
      <Button className={className} {...buttonProps}>
        {buyLabel}
      </Button>
    );
  }

  return (
    <div className={`DiscountButton ${className}`}>
      <div className="DiscountButton__savings">
        {saveLabel}{' '}
        <span className="DiscountButton__savings-amount">
          {formattedSavings} ({discountPercent}%)
        </span>
      </div>
      <Button {...buttonProps} className="DiscountButton__action">
        {buyLabel}
      </Button>
    </div>
  );
};
